// 适配 Nginx 反向代理
const api = {
  state: {
    // 部署包上传
    orderImportApi: '/api/order/upload'
  }
}

export default api
